import { Overlay } from '@radix-ui/react-dialog'
import { cn } from '@seen/ui'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'

type OverlayProps = ComponentPropsWithoutRef<typeof Overlay>

export interface SheetOverlayProps extends OverlayProps {
  asChild?: OverlayProps['asChild']
  forceMount?: OverlayProps['forceMount']
  /**
   * Data attributes:
   *   [data-state]: "open" | "closed"
   */
  className?: OverlayProps['className']
}

export const SheetOverlay = forwardRef<
  ElementRef<typeof Overlay>,
  SheetOverlayProps
>(({ className, ...delegated }, ref) => (
  <Overlay
    className={cn(
      'data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 bg-black/10 data-[state=closed]:animate-out data-[state=open]:animate-in',
      className
    )}
    {...delegated}
    ref={ref}
  />
))
SheetOverlay.displayName = Overlay.displayName
